import { Component, Input, OnInit, inject } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { MinimalProvider } from 'app/core/models/minimal-provider.model';
import { PatientAttachment } from 'app/core/models/patient-attachment.model';
import { ReferralSpecialty } from 'app/core/models/referral-specialty.model';
import { PatientAttachmentsService } from 'app/core/services/patient-attachments.service';
import { map, uniqBy } from 'lodash-es';
import { NgSelectComponent } from '@ng-select/ng-select';
import { FormsModule } from '@angular/forms';
import { AdditionalDetailsInputComponent } from '../../../shared/components/additional-details-input/additional-details-input.component';

import { PrescriberNameComponent } from '../../../shared/components/prescriber-name/prescriber-name.component';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@Component({
    selector: 'app-consult-note-edit-specialty',
    templateUrl: './consult-note-edit-specialty.component.html',
    styleUrl: './consult-note-edit-specialty.component.scss',
    imports: [NgSelectComponent,
              FormsModule,
              AdditionalDetailsInputComponent,
              PrescriberNameComponent,
              MatProgressSpinner]
})
export class ConsultNoteEditSpecialtyComponent implements OnInit {
  private activeModal = inject(NgbActiveModal);
  private patientAttachmentsService = inject(PatientAttachmentsService);

  @Input() patientAttachment: PatientAttachment;
  @Input() referralSpecialties: ReferralSpecialty[];

  uniqueProviders: MinimalProvider[];
  loadingProviders = true;

  ngOnInit(): void {
    this.patientAttachmentsService.getVerifyingCaptures(this.patientAttachment.id).subscribe((captures) => {
      const providers = map(captures, 'provider');
      this.uniqueProviders = uniqBy(providers, 'id');
      this.loadingProviders = false;
    })
  }

  onCancelClick(): void {
    this.activeModal.dismiss();
  }

  onSaveClick($event: Event): void {
    $event.preventDefault();

    this.patientAttachmentsService.updateSpecialty(this.patientAttachment).subscribe((pa: PatientAttachment) => {
      const modifiedPatientAttachment: PatientAttachment = Object.assign({}, this.patientAttachment);
      modifiedPatientAttachment.selectedSpecialty = pa.selectedSpecialty;
      modifiedPatientAttachment.selectedSpecialtyAdditionalDetails = pa.selectedSpecialtyAdditionalDetails;
      modifiedPatientAttachment.selectedSpecialtyFrozen = pa.selectedSpecialtyFrozen;
      modifiedPatientAttachment.hasMatchingSpecialtyPmvs = pa.hasMatchingSpecialtyPmvs;
      this.patientAttachmentsService.notifyPatientAttachmentChanged(modifiedPatientAttachment);
      this.activeModal.close();
    });
  }
}
